import React from 'react';
import {
  Table,
  Thead,
  Tfoot,
  Tbody,
  Tr,
  Th,
  Td,
  TableContainer,
} from '@chakra-ui/react';
import usePartnersTable from './services/usePartnersTable';

function formatNumber(number) {
  if (Number.isNaN(number) || number === 0) return '0';

  return new Intl.NumberFormat('ru-RU', { maximumFractionDigits: 2 }).format(
    number
  );
}

export default function PartnersTable({ env, startedFrom, finishedTo, partners }) {
  const { tableData, totalPaymentCount, totalPayoutCount } = usePartnersTable({
    env,
    startedFrom,
    finishedTo,
  });

  return (
    <TableContainer>
      <Table variant="striped" size="sm">
        <Thead>
          <Tr>
            <Th>Мерчант</Th>
            <Th isNumeric>Конверсия платежей</Th>
            <Th isNumeric>Платежи</Th>
            <Th isNumeric>Конверсия выплат</Th>
            <Th isNumeric>Выплаты</Th>
          </Tr>
        </Thead>
        <Tbody>
          {partners.map((partner, idx) => {
            return (
              <Tr key={idx}>
                <Td>
                  {partner.login}
                  <br />({partner.name})
                </Td>
                <Td isNumeric>
                  {(tableData[partner.id] &&
                    formatNumber(
                      (tableData[partner.id].chargedPaymentCount /
                        totalPaymentCount) *
                        100
                    )) ||
                    0}
                  %
                </Td>
                <Td isNumeric>
                  {(tableData[partner.id] &&
                    formatNumber(tableData[partner.id].paymentCount)) ||
                    0}
                </Td>
                <Td isNumeric>
                  {(tableData[partner.id] &&
                    formatNumber(
                      (tableData[partner.id].chargedPayoutCount /
                        totalPayoutCount) *
                        100
                    )) ||
                    0}
                  %
                </Td>
                <Td isNumeric>
                  {(tableData[partner.id] &&
                    formatNumber(tableData[partner.id].payoutCount)) ||
                    0}
                </Td>
              </Tr>
            );
          })}

          {partners.length === 0 && (
            <Tr>
              <Td colSpan={5} bgColor={'white !important'}>
                <p className="no-data">Нет данных</p>
              </Td>
            </Tr>
          )}
        </Tbody>
        <Tfoot>
          <Tr>
            <Th>Итого:</Th>
            <Th></Th>
            <Th isNumeric>{formatNumber(totalPaymentCount)}</Th>
            <Th isNumeric></Th>
            <Th isNumeric>{formatNumber(totalPayoutCount)}</Th>
          </Tr>
        </Tfoot>
      </Table>
    </TableContainer>
  );
}
